// extracted by mini-css-extract-plugin
export var chevron = "_49-d";
export var disabled = "_49-b";
export var error = "_49-c";
export var hideBorder = "_49-1";
export var icon = "_49-e";
export var input = "_49-0";
export var large = "_49-f";
export var open = "_49-9";
export var placeholder = "_49-a";
export var regular = "_49-5";
export var singleRowInput = "_49-2";
export var singleSelectInput = "_49-3 _49-0";
export var small = "_49-4";
export var spinnerContainer = "_49-i";
export var tag = "_49-7";
export var tagsContainer = "_49-8";
export var tagsInput = "_49-6 _49-0";
export var xSmall = "_49-g";
export var xxSmall = "_49-h";